import { useParams, Link } from 'react-router-dom';
import { categories, mangaList } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function CategoryPage() {
  const { slug = 'all' } = useParams();
  const currentCategory = categories.find(c => c.slug === slug) || categories[0];

  let filteredManga = mangaList;
  if (slug === 'hot') {
    filteredManga = mangaList.filter(m => m.isHot);
  } else if (slug === 'new') {
    filteredManga = mangaList.filter(m => m.isNew);
  } else if (slug !== 'all') {
    filteredManga = mangaList.filter(m => m.category === slug);
  }

  const sortManga = [...filteredManga].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime());

  return (
    <main className="pt-16">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <Breadcrumb items={[
          { label: '首页', href: '/' },
          { label: currentCategory.name },
        ]} />

        {/* Category Header */}
        <div className="py-6">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            {currentCategory.name}韩漫
          </h1>
          <p className="text-sm text-foreground-500 mt-2">
            共 {sortManga.length} 部{currentCategory.name !== '全部' ? currentCategory.name : ''}韩漫作品
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex items-center gap-2 overflow-x-auto pb-3 flex-wrap mb-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${slug === cat.slug ? 'bg-primary-500 text-background-50 dark:text-foreground-950' : 'bg-background-100 text-foreground-700 hover:bg-background-200'}`}
            >
              <i className={`${cat.icon} text-base`}></i>
              {cat.name}
            </Link>
          ))}
        </div>

        {/* Manga Grid */}
        {sortManga.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5 pb-14">
            {sortManga.map((manga) => (
              <MangaCard key={manga.id} manga={manga} />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-book-line text-3xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
            <Link to="/" className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600">返回首页 <i className="ri-arrow-right-line"></i></Link>
          </div>
        )}

        {/* SEO Structured Data */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": `${currentCategory.name}韩漫 - 韩漫之家`,
          "description": `韩漫之家${currentCategory.name}韩漫分类，共${sortManga.length}部作品，支持韩漫在线观看，免费韩漫大全。`,
          "url": `https://www.hanmanzhijia.com/category/${slug}`,
          "isPartOf": { "@type": "WebSite", "name": "韩漫之家", "url": "https://www.hanmanzhijia.com" }
        }) }} />
      </div>
    </main>
  );
}